import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const resetPassword = createAsyncThunk(
  "veloxityResetPassword/resetPassword",
  async ({ token, password }, { rejectWithValue }) => {
    try {
      const apiClient = new APIClient();
      const response = await apiClient.create(
        `/api/v1/otp/reset-password/verify`,
        { token, password }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const veloxityResetPasswordSlice = createSlice({
  name: "veloxityResetPassword",
  initialState: {
    loading: false,
    successMsg: null,
    error: false,
    errorMsg: null,
  },
  reducers: {
    resetPasswordState: (state) => {
      state.loading = false;
      state.successMsg = null;
      state.error = false;
      state.errorMsg = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.successMsg = null;
        state.errorMsg = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.successMsg = action.payload?.message || 'Password reset successfully';
        state.error = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.errorMsg = action.payload?.message || 'An error occurred';
      });
  },
});

export const { resetPasswordState } = veloxityResetPasswordSlice.actions;
export default veloxityResetPasswordSlice.reducer;
